import React, { useContext, VFC } from 'react';

import ArticleBlock from '/components/ArticleBlock';
import { MediaColumn } from '/components/BlockColumns';
import { BlockProps, ColumnContainerJson } from '/types';
import { PresentModeContext } from '/utils/contexts';
import { contentFilter } from '/utils/functions';
import useAnimation from '/utils/useAnimation';

const BlockInfographic: VFC<BlockProps> = ({
  animationEnabled,
  animationStep,
  setAnimationComplete,
  blockContent,
  presentOption,
  ...props
}) => {
  const presentMode = useContext(PresentModeContext);
  const columnData = blockContent?.columns?.list || [];
  const contextContent = contentFilter(
    blockContent.context,
    presentMode,
    presentOption,
  );
  const preChartSteps = animationEnabled ? 1 : 0;
  const columns = useAnimation(
    columnData,
    presentMode,
    animationStep,
    preChartSteps,
    setAnimationComplete,
  );

  return (
    <ArticleBlock
      {...props}
      blockContent={blockContent}
      contextContent={contextContent}
      hideContext={animationEnabled && !animationStep}
      hideFooter={animationEnabled && !animationStep}
      titleCentered
      columns={columns.map((column: ColumnContainerJson) => (
        <>
          {!column.hidden && column.name === 'media' && (
            <MediaColumn
              elements={column.elements}
              imageSize={{ width: 1600, aspect: '1600/646' }}
              presentOption={presentOption}
              hide={animationEnabled && !animationStep}
            />
          )}
        </>
      ))}
    />
  );
};

BlockInfographic.displayName = 'BlockInfographic';
export default BlockInfographic;
